
import { useContext } from '@nuxtjs/composition-api';
import useCheckout from '~/composable/checkout/useCheckout';
import { CUSTOMER_SUBSCRIPTION_TYPE } from '~/constants/CheckoutFlow';

export default {
  props: {
    isPreOrBackOrder: {
      type: Boolean,
      default: false
    },
    hasSpecialPrices: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const { app } = useContext()
    const { state } = useCheckout(app)
    const { menu } = state?.subscription || {}

    return {
      CUSTOMER_SUBSCRIPTION_TYPE,
      menu
    };
  }
}
